<template>
    <div>
        <div class="boxes">
            <el-collapse class="formset__list">
                <div v-for="box, i in form.boxes" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="`${box.title_pl || 'Nowy box'}`"
                                            :errors="checkForErrors(errors.boxes, [i])"
                                            :items.sync="form.boxes"
                                            :index="i"/>
                        </template>
                        <el-form-item label="Tytuł"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['title']">
                            <el-input v-model="box[addLanguageSuffix('title')]">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Opis"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['description']">
                            <wyswig-input v-model="box[addLanguageSuffix('description')]"
                                          simple/>
                        </el-form-item>
                        <el-form-item label="">
                            <el-tooltip placement="top" effect="light">
                                <div slot="content">
                                    <img src="/static/help/boxes.png" alt="">
                                </div>
                                <el-button type="info" size="mini">
                                    <i class="fa fa-question-circle"></i> Pomocnicze informacje dotyczące grafik
                                </el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="Grafika (motyw)"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['image']">
                            <image-input-component v-model="box.image"/>
                        </el-form-item>
                        <el-form-item label="Zdjęcie"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['photo']">
                            <image-input-component v-model="box.photo"/>
                        </el-form-item>
                        <el-form-item label="Kolor tła"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['bg_color']">
                            <el-color-picker v-model="box.bg_color"/>
                        </el-form-item>
                        <el-form-item label="Kolor tekstu"
                                      :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['text_color']">
                            <el-color-picker v-model="box.text_color"/>
                        </el-form-item>
                        <el-form-item label="Przycisk">
                            <el-form-item label="Nazwa"
                                          :error="errors.boxes && errors.boxes[i] && errors.boxes[i]['button_title']">
                                <el-input v-model="box[addLanguageSuffix('button_title')]">
                                </el-input>
                            </el-form-item>
                            <link-component v-model="box.button_link"
                                            :key="box.key || box.id"
                                            :errors="errors.boxes && errors.boxes[i] && errors.boxes[i]['button_link']">
                            </link-component>
                        </el-form-item>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection">+ box</el-button>
        </div>
    </div>
</template>
<script>
    import {Tag} from '@/api'
    import uniqueId from 'lodash.uniqueid'

    export default {
        props: ['form', 'errors'],
        methods: {
            addSection () {
                const blankObject = {
                    key: uniqueId()
                }
                if (!Array.isArray(this.form.boxes)) {
                    this.$emit('update:form', {
                        ...this.form,
                        boxes: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.boxes.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// BoxesWidget.vue?11931842